/**
 * Yield the main thread so the browser can paint / handle input.
 * Prefer `scheduler.yield` when available (Chrome), else setTimeout(0).
 */
export function yieldToMain(): Promise<void> {
    const scheduler = (globalThis as { scheduler?: { yield?: () => Promise<void> } }).scheduler
    if (scheduler?.yield) {
        return scheduler.yield()
    }
    return new Promise((resolve) => {
        setTimeout(resolve, 0)
    })
}
